import { Box, Modal } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from '@/components/ui/Loader/Loader';

import ModalStyle from '@/constants/ModalStyle';
import alert from '@/assets/icons/alert.png';
import usePatch from '../../../hooks/usePatch';
import { toast } from 'react-toastify';

export default function Delete(props) {
	const { open, onClose, id, project } = props;
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const type = project?.productprefix_detail ? project.productprefix_detail[0]?.productprefix : project?.component_prefix_name;
	const number = project?.productcodenumber || project?.component_code_number;
	const ver = project?.productversion || project?.component_productversion;

	const callback = () => {
		if (project.componentid) {
			dispatch({ type: 'trigger/triggerAPI', payload: { key: 'projectDetail' } });
		} else {
			navigate(`/`);
		}
	};

	const {
		mutate: deleteProject,
		isPending,
		isSuccess,
	} = usePatch({
		url: `component/${id}`,
		method: 'delete',
		callback: (res) => {
			if (res.status === 200) {
				toast.success(`project deleted`);
				callback();
			}
		},
		onError: () => {},
		showError: true,
	});

	const onDeleteProject = () => {
		if (!id || !project) return;
		deleteProject();
	};
	return (
		<Modal open={open} onClose={onClose} aria-labelledby='modal-project-qr' aria-describedby='modal-project-qr' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25svh' }} className='!bg-bd-blue relative flex flex-col gap-4 min-w-[300px] w-auto h-auto'>
				<div className='flex flex-col items-center justify-center w-full h-auto gap-4 text-center'>
					<img src={alert} alt='warning' />
					{isPending && !isSuccess && <Loader />}

					<div className='flex flex-col text-white'>
						<span>Er du sikker på at du vil slette </span>
						<span>
							{type} - {number} {ver ? `ver:${ver}` : ''}?
						</span>
					</div>
					<div className='flex gap-4'>
						<button className='bg-[#81B8DD] btn text-bd-blue' onClick={onClose}>
							Nei
						</button>
						<button className='bg-white btn text-bd-blue' onClick={onDeleteProject} disabled={!id || !project}>
							Ja
						</button>
					</div>
				</div>
			</Box>
		</Modal>
	);
}
